<i18n>
{
  "fr":{
    "Name": "Nom du programmeur",
    "StartDate": "Date de début",
    "EndDate": "Date de fin"
  }
}
</i18n>

<template>
  <section>
    <BaseForm @submit="generate()">
      <UserPicker
        v-model="form.member"
        source="ConnectWise"
        validate="required"
        @input="generate" />
    </Baseform>
  </section>
</template>

<script>
import UserPicker from './UserPicker';

export default {
  components: {
    UserPicker,
  },
  props: {
    source: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      form: {
        member: null,
      },
    };
  },
  created() {
    if (this.form.member) {
      this.generate();
    }
  },
  methods: {
    async generate() {
      this.$emit('submit', {
        member: this.form.member,
      });
    },
  },
};
</script>
